<template>
  <div class="tags tags--horizontal">
    <div class="tags__wrapper">
      <div class="tags__scroll">
        <div class="tags__title">{{ label }}</div>
        <div v-if="showTagCloseIcon" class="tags__tags">
          <button
            v-for="(item, index) in tagItems"
            :key="`tag-${index}-${item}`"
            :class="[
              `tags__tag` ,
              `tags__tag--action` ,
              `tags__tag--icon--right` ,
            ]"
            @click="onClick(item)"
          >
            {{ item }}
            <icon class-name="tags__tag__icon" name="times" />
          </button>
        </div>
        <div v-else class="tags__tags">
          <div
            v-for="(item, index) in tagItems"
            :key="`tag-${index}-${item}`"
            class="tags__tag"
          >{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import Icon from "../Icon/Icon.vue";

export default {
  name: "Tags",
  components: {
    Icon,
  },
  props: {
    /**
     * @description
     * Provides Label to the Tags
     */
    label: {
      type: String,
      default: "Default Tag Label!",
    },
    /**
     * @description
     * Provides Tags Items to the Tags
     */
    tagItems: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * @description
     * Flag to show Remove Icon on the Tags
     */
    showTagCloseIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * @description
     * On Click of the Remove Icon it will remove item from the Array
     * It Will Emit the updated Array to the Parent Component
     * Parent Component needs to maintain state
     */
    onClick(item) {
      const updatedTagItems = this.tagItems.filter(
        (element) => element !== item
      );
      this.$emit("onClick", updatedTagItems);
    },
  },
};
</script>